function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  "data-name": "Icon awesome-heart",
  d: "M8.401.552a2.485 2.485 0 00-3.39.247l-.358.369-.358-.369A2.485 2.485 0 00.901.552a2.609 2.609 0 00-.18 3.777l3.516 3.63a.57.57 0 00.823 0l3.516-3.63A2.607 2.607 0 008.401.552z",
  fill: "#002f4d"
});
var SvgHeartSmallNavy = function SvgHeartSmallNavy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9.303,
    height: 8.14
  }, props), _ref);
};
export default SvgHeartSmallNavy;